/** @format */

import Table from "../../extra/Table";
import Button from "../../extra/Button";
import { connect, useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import ToggleSwitch from "../../extra/ToggleSwitch";
import Pagination from "../../extra/Pagination";
import { getKosLocations, syncKosLocations, updateKosLocation, getKosStates } from "../../store/kosLocation/kosLocation.action";

const KosLocations = (props) => {
	const [page, setPage] = useState(0);
	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(true);
	const [rowsPerPage, setRowsPerPage] = useState(25);
	const [stateFilter, setStateFilter] = useState("");
	const [search, setSearch] = useState("");
	const [syncing, setSyncing] = useState(false);
	const dispatch = useDispatch();

	const { locations, states } = useSelector((state) => state.kosLocation);

	useEffect(() => {
		dispatch(getKosLocations());
		dispatch(getKosStates());
	}, [dispatch]);

	useEffect(() => {
		const timer = setTimeout(() => setLoading(false), 1000);
		return () => clearTimeout(timer);
	}, []);

	useEffect(() => {
		let filtered = locations || [];
		if (stateFilter) {
			filtered = filtered.filter((loc) => loc.state?.name === stateFilter);
		}
		if (search) {
			const s = search.toLowerCase();
			filtered = filtered.filter((loc) => (loc.name || "").toLowerCase().includes(s) || (loc.address || "").toLowerCase().includes(s) || (loc.lga?.name || "").toLowerCase().includes(s));
		}
		setData(filtered);
		setPage(0);
	}, [locations, stateFilter, search]);

	const handleChangePage = (event, newPage) => setPage(newPage);
	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event, 10));
		setPage(0);
	};

	const handleSync = () => {
		setSyncing(true);
		dispatch(syncKosLocations());
		setTimeout(() => setSyncing(false), 3000);
	};

	const handleToggleActive = (row) => {
		dispatch(updateKosLocation(row._id, { isActive: !row.isActive }));
	};

	const handleZoneChange = (row, zone) => {
		if (zone === "__new") {
			const newZone = window.prompt("Enter new zone name:");
			if (newZone && newZone.trim()) {
				dispatch(updateKosLocation(row._id, { zone: newZone.trim() }));
			}
			return;
		}
		dispatch(updateKosLocation(row._id, { zone }));
	};

	const uniqueZones = [...new Set((locations || []).map((l) => l.zone).filter(Boolean))].sort();

	const mapData = [
		{
			Header: "No",
			width: "20px",
			Cell: ({ index }) => <span>{page * rowsPerPage + parseInt(index) + 1}</span>,
		},
		{
			Header: "Hub Name",
			body: "name",
			sorting: true,
			Cell: ({ row }) => <span className='fw-bold'>{row?.name || "-"}</span>,
		},
		{
			Header: "State",
			body: "state.name",
			sorting: true,
			Cell: ({ row }) => <span>{row?.state?.name || "-"}</span>,
		},
		{
			Header: "LGA",
			body: "lga.name",
			sorting: true,
			Cell: ({ row }) => <span>{row?.lga?.name || "-"}</span>,
		},
		{
			Header: "Address",
			body: "address",
			Cell: ({ row }) => (
				<span style={{ maxWidth: "250px", display: "inline-block", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }} title={row?.address}>
					{row?.address || "-"}
				</span>
			),
		},
		{
			Header: "Phone",
			body: "phone",
			Cell: ({ row }) => <span>{row?.phone || "-"}</span>,
		},
		{
			Header: "Zone",
			body: "zone",
			Cell: ({ row }) => (
				<select value={row?.zone || "default"} onChange={(e) => handleZoneChange(row, e.target.value)} style={{ padding: "4px 8px", borderRadius: "6px", border: "1px solid #ddd", fontSize: "13px" }}>
					<option value='default'>default</option>
					{uniqueZones
						.filter((z) => z !== "default")
						.map((z) => (
							<option key={z} value={z}>
								{z}
							</option>
						))}
					<option value='__new'>+ New Zone...</option>
				</select>
			),
		},
		{
			Header: "Active",
			body: "isActive",
			Cell: ({ row }) => (
				<div className='boxCenter'>
					<ToggleSwitch value={row?.isActive} onClick={() => handleToggleActive(row)} />
				</div>
			),
		},
		{
			Header: "KOS ID",
			body: "kosId",
			Cell: ({ row }) => <span style={{ color: "#999", fontSize: "12px" }}>{row?.kosId}</span>,
		},
	];

	return (
		<>
			<div className='mainSellerTable'>
				<div className='sellerTable'>
					<div className='col-12 headname'>KOS Locations (Drop-off Hubs)</div>
					<div className='sellerMain'>
						<div className='tableMain mt-2'>
							<div className='sellerHeader primeHeader'>
								<div className='row align-items-center'>
									<div className='col-md-3'>
										<Button newClass={`whiteFont`} btnColor={`btnBlackPrime`} btnIcon={`fa-solid fa-rotate`} btnName={syncing ? "Syncing..." : "Sync from KOS"} onClick={handleSync} style={{ borderRadius: "8px", padding: "8px 24px", background: "#e54a13", opacity: syncing ? 0.7 : 1 }} />
									</div>
									<div className='col-md-3'>
										<select value={stateFilter} onChange={(e) => setStateFilter(e.target.value)} style={{ width: "100%", padding: "8px 12px", borderRadius: "8px", border: "1px solid #ddd", fontSize: "14px" }}>
											<option value=''>All States</option>
											{(states || []).map((s) => (
												<option key={s.id} value={s.name}>
													{s.name} ({s.locationCount})
												</option>
											))}
										</select>
									</div>
									<div className='col-md-4'>
										<input type='text' placeholder='Search hubs by name, address, LGA...' value={search} onChange={(e) => setSearch(e.target.value)} style={{ width: "100%", padding: "8px 12px", borderRadius: "8px", border: "1px solid #ddd", fontSize: "14px" }} />
									</div>
									<div className='col-md-2 text-end'>
										<span style={{ fontSize: "14px", color: "#666" }}>
											{data.length} location{data.length !== 1 ? "s" : ""}
										</span>
									</div>
								</div>
							</div>
							<Table data={data} mapData={mapData} PerPage={rowsPerPage} Page={page} type={"client"} />
							<Pagination component='div' count={data?.length} serverPage={page} type={"client"} onPageChange={handleChangePage} serverPerPage={rowsPerPage} totalData={data?.length} onRowsPerPageChange={handleChangeRowsPerPage} />
						</div>
					</div>
					<div className='sellerFooter primeFooter'></div>
				</div>
			</div>
		</>
	);
};

export default connect(null, { getKosLocations, syncKosLocations, updateKosLocation, getKosStates })(KosLocations);
